export class GenericTypeDef {
  id: number = 0;
  code: string = '';
  name: string = '';
  description: string = '';
}
